// @ts-nocheck
// ─── CONFIG ────────────────────────────────────────────────────────────────────
const GADGET_ROUTE_URL = "https://sadpe-shopify-connector.gadget.app/create-draft-order";

// ─── TOAST NOTIFICATION ────────────────────────────────────────────────────────
function showToast(message, type = "error", duration = 4000) {
  // Intentar usar el sistema nativo de Horizon si está disponible
  const existingToast = document.querySelector("toast-component, .toast, [data-toast]");
  if (existingToast && typeof existingToast.show === "function") {
    existingToast.show(message, type);
    return;
  }

  // Fallback: toast propio integrado visualmente con Horizon
  const id = "gc-toast-" + Date.now();
  const isError = type === "error";

  const toast = document.createElement("div");
  toast.id = id;
  toast.setAttribute("role", "alert");
  toast.setAttribute("aria-live", "assertive");
  toast.style.cssText = `
    position: fixed;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%) translateY(0);
    z-index: 99999;
    background: ${isError ? "#c0392b" : "#27ae60"};
    color: #fff;
    padding: 14px 24px;
    border-radius: 8px;
    font-size: 14px;
    font-family: inherit;
    box-shadow: 0 4px 20px rgba(0,0,0,0.18);
    display: flex;
    align-items: center;
    gap: 10px;
    max-width: 90vw;
    animation: gcToastIn 0.3s ease;
  `;

  toast.innerHTML = `
    <span>${isError ? "⚠️" : "✓"}</span>
    <span>${message}</span>
    <button onclick="document.getElementById('${id}')?.remove()" style="
      background:none; border:none; color:#fff; cursor:pointer;
      font-size:18px; line-height:1; margin-left:8px; opacity:0.8;
    ">×</button>
  `;

  // Agregar keyframes si no existen
  if (!document.getElementById("gc-toast-styles")) {
    const style = document.createElement("style");
    style.id = "gc-toast-styles";
    style.textContent = `
      @keyframes gcToastIn {
        from { opacity: 0; transform: translateX(-50%) translateY(16px); }
        to   { opacity: 1; transform: translateX(-50%) translateY(0); }
      }
    `;
    document.head.appendChild(style);
  }

  document.body.appendChild(toast);
  setTimeout(() => toast.remove(), duration);
}

// Para precios que vienen de /products.json (ya en euros, ej: "120.00")
function formatPriceFromDecimal(euroAmount) {
  const amount = parseFloat(euroAmount);
  return new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount) + " " + currency_symbol;
}

// ─── INIT ───────────────────────────────────────────────────────────────────────
document.addEventListener("DOMContentLoaded", () => {
  const root = document.querySelector(".giftcards-page");
  if (!root) return;

  // Elements
  const previewImg     = root.querySelector("#gcPreviewImage");
  const previewAmount  = root.querySelector("#gcPreviewAmount");
  const previewProduct = root.querySelector("#gcPreviewProduct");
  const form           = root.querySelector("#giftcardForm");
  const variantInput   = root.querySelector("#gc_variant_id");
  const addBtn         = root.querySelector("#gcAddButton");
  const catButtons     = root.querySelectorAll(".gc-cat-btn");

  // State
  let currentAllowCustom = false;
  let currentTemplate    = "Beldon Beauty"; // default

  // ─── HELPERS ──────────────────────────────────────────────────────────────────

  function centsToDecimal(price) {
    return Number(price) / 100;
  }

  function formatPrice(cents) {
    const amount = centsToDecimal(cents);
    return new Intl.NumberFormat(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount) + " " + currency_symbol;
  }

  function parseVariants(el) {
    try {
      return JSON.parse(el.dataset.variants || "[]");
    } catch {
      return [];
    }
  }

  function pickVariant(variants) {
    return variants.find(v => v.available) || variants[0] || null;
  }

  function getFormProperties() {
    const properties = {};
    form.querySelectorAll('[name^="properties["]').forEach(el => {
      // Para radios, solo tomar el que está checked
      if (el.type === "radio" && !el.checked) return;
      const key = el.name.slice(11, -1);
      if (el.value.trim() !== "") {
        properties[key] = el.value.trim();
      }
    });
    properties["Card Template"] = currentTemplate;
    return properties;
  }

  // ─── TRUNCATE CON ELLIPSIS ────────────────────────────────────────────────────

  function truncate(str, maxLength = 180) {
    if (!str) return "";
    const clean = str.replace(/\s+/g, " ").trim();
    if (clean.length <= maxLength) return clean;
    return clean.substring(0, maxLength).trimEnd() + "…";
  }

  // ─── DESCRIPCIÓN SOBRE EL FORM ────────────────────────────────────────────────

  function updateSelectedInfo(title, description) {
    const info = document.getElementById("gcSelectedInfo");
    const desc = document.getElementById("gcSelectedDescription");
    if (!info || !desc) return;

    if (description?.trim() || title?.trim()) {
      desc.innerHTML = title?.trim()
        ? `<h2 class="gc-selected-title">${title}</h2>${description || ""}`
        : description || "";
      info.style.display = "block";
    } else {
      info.style.display = "none";
    }
  }

  // ─── AJAX: CARGAR COLECCIÓN COMPLETA ──────────────────────────────────────────

  async function fetchCollectionProducts(handle) {
    try {
      const res = await fetch(`/collections/${handle}/products.json?limit=250`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      return data.products || [];
    } catch (err) {
      console.error(`Error cargando colección "${handle}":`, err);
      return [];
    }
  }

  function buildAmountButton(product, blockData) {
    const variants = product.variants || [];
    const div = document.createElement("div");
    div.className = "gc-list-item-wrap";

    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "giftcard-option gc-item gc-item--amount gc-product-item";
    btn.dataset.type         = "amount";
    btn.dataset.blockId      = blockData.blockId;
    btn.dataset.title        = product.title;
    btn.dataset.image        = product.images?.[0]?.src || "";
    btn.dataset.variants     = JSON.stringify(variants);
    btn.dataset.allowCustom  = blockData.allowCustom;
    btn.dataset.presetAmounts = blockData.presetAmounts;
    btn.dataset.handle       = product.handle || "";
    btn.dataset.description = product.body_html || "";

    btn.innerHTML = `
      <div class="gc-item-main">
        <strong class="gc-item-title">${product.title}</strong>
        <span class="gc-item-select"></span>
      </div>
    `;

    div.appendChild(btn);
    return div;
  }

  function buildServiceCard(product, category) {
    const variants = product.variants || [];
    const price = variants[0]?.price ? formatPriceFromDecimal(variants[0].price) : "";
    const fullDesc = product.body_html || "";
    const shortDesc = truncate(product.body_html?.replace(/<[^>]+>/g, "") || "", 180);

    const article = document.createElement("article");
    article.className = "gc-service-card";
    article.dataset.category     = category;
    article.dataset.variants     = JSON.stringify(variants);
    article.dataset.title        = product.title;
    article.dataset.handle       = product.handle || "";
    article.dataset.image        = product.images?.[0]?.src || "";
    article.dataset.priceDisplay = price;
    article.dataset.description = fullDesc;
    article.style.display = "none";

    article.innerHTML = `
      <div class="gc-service-card-inner">
        <div class="gc-service-info">
          <h3 class="gc-service-name">${product.title}</h3>
          <p class="gc-service-desc">${shortDesc}</p>
        </div>
        <div class="gc-service-meta">
          <div class="gc-service-price">${price}</div>
        </div>
        <button type="button" class="gc-service-select" aria-label="Seleccionar"></button>
      </div>
    `;

    return article;
  }

  // ─── POBLAR COLECCIONES VÍA AJAX ──────────────────────────────────────────────

  async function loadAllCollections() {
    const collectionGroups = root.querySelectorAll(".gc-collection-group");

    await Promise.all([...collectionGroups].map(async (groupEl) => {
      const handle        = groupEl.dataset.collectionHandle;
      const group         = groupEl.dataset.group;
      const blockId       = groupEl.dataset.blockId;
      const category      = groupEl.dataset.serviceCategory || "";
      const allowCustom   = groupEl.dataset.allowCustom || "false";
      const presetAmounts = groupEl.dataset.presetAmounts || "";

      const products = await fetchCollectionProducts(handle);
      if (products.length === 0) return;

      groupEl.innerHTML = "";

      products.forEach(product => {
        if (group === "amount") {
          const el = buildAmountButton(product, { blockId, allowCustom, presetAmounts });
          groupEl.appendChild(el);
        } else if (group === "service") {
          const el = buildServiceCard(product, category);
          groupEl.appendChild(el);
        }
      });

      if (group === "amount") {
        bindAmountButtons(groupEl.querySelectorAll(".giftcard-option"));
      } else {
        bindServiceCards(groupEl.querySelectorAll(".gc-service-card"));
      }
    }));

    // Si viene ?gc= en la URL, auto-seleccionar esa tarjeta.
    // Si no, activar la primera categoría de servicios como antes.
    const gcParam = new URLSearchParams(window.location.search).get("gc");
    if (gcParam) {
      autoSelectFromUrl();
    } else {
      const firstCat = root.querySelector(".gc-cat-btn");
      if (firstCat) firstCat.click();
    }
  }

  // ─── UI UPDATES ───────────────────────────────────────────────────────────────

  function setActiveEl(el, groupSelector) {
    if (el?.classList.contains("active")) {
      el.classList.remove("active");
      root.querySelectorAll(groupSelector).forEach(x => x.classList.remove("is-hidden"));
      document.getElementById("gcFormWrap").classList.add("is-hidden");
      document.querySelectorAll(".gc-col--panel").forEach(p => p.classList.remove("active"));
    } else {
      root.querySelectorAll(groupSelector).forEach(x => {
        x.classList.remove("active");
        x.classList.add("is-hidden");
      });
      el?.classList.remove("is-hidden");
      el?.classList.add("active");
      document.querySelectorAll(".gc-col--panel").forEach(p => p.classList.add("active"));
      document.getElementById("gcFormWrap").classList.remove("is-hidden");
    }
  }

  function updatePreview({ title, image, priceDisplay }) {
    if (previewProduct) previewProduct.textContent = title || "—";
    if (previewAmount)  previewAmount.textContent  = priceDisplay || "—";
    if (previewImg)     previewImg.src             = image || "";
  }

  function updateVariantInput(variant) {
    if (!variant || !variantInput) return;
    variantInput.value = variant.id;
    // Guardar el precio del variant seleccionado (viene como decimal string desde /products.json)
    // lo convertimos a centavos para mantener consistencia con el Liquid
    variantInput.dataset.price = Math.round(parseFloat(variant.price) * 100);
  }

  // ─── TEMPLATE DE TARJETA ──────────────────────────────────────────────────────

  function applyCardTemplate(handle) {
    const allTemplates = typeof gcProductTemplates !== "undefined" ? gcProductTemplates : {};
    const allConfigs   = typeof gcTemplateConfig   !== "undefined" ? gcTemplateConfig   : {};

    const templateName = allTemplates[handle] || "Beldon Beauty";
    const config       = allConfigs[templateName] || allConfigs["Beldon Beauty"];
    if (!config) return;

    currentTemplate = templateName;

    // Actualizar el input hidden del form para que llegue como line item property
    const tmplInput = document.getElementById("gcCardTemplateProp");
    if (tmplInput) tmplInput.value = templateName;

    // Cambiar logo
    const logo = document.getElementById("gcModalLogo");
    if (logo) {
      logo.src = config.logo;
      logo.alt = templateName;
    }

    // Cambiar título de tarjeta
    const cardType = document.getElementById("gcModalCardType");
    if (cardType) cardType.textContent = config.cardType;

    // Cambiar clase CSS del card inner (para colores/fondo via CSS)
    const cardInner = document.getElementById("gcPreviewModal");
    if (cardInner) {
      cardInner.classList.remove("gc-card--beauty", "gc-card--medical", "gc-card--wellness");
      cardInner.classList.add(config.cssClass);
    }

    // Aplicar clase también al modal completo (para estilos desde la raíz)
    const modal = document.getElementById("gcPreviewModal");
    if (modal) {
      modal.classList.remove("gc-modal--beauty", "gc-modal--medical", "gc-modal--wellness");
      modal.classList.add(config.cssClass.replace("gc-card--", "gc-modal--"));
    }

    // Actualizar dirección
    const addressEl = document.getElementById("gcModalAddress");
    if (addressEl && config.address) {
      addressEl.innerHTML = config.address.map(line => `<p>${line}</p>`).join("");
    }
  }

  function showCustomPriceField(show) {
    const field = root.querySelector("#customAmountField");
    if (field) field.style.display = show ? "block" : "none";
    if (!show) {
      const input = root.querySelector("#gcCustomPrice");
      if (input) input.value = "";
    }
  }

  // ─── PRESET AMOUNTS ───────────────────────────────────────────────────────────

  function renderPresetAmounts(csvString) {
    const container = root.querySelector("#gcPresetAmounts");
    if (!container) return;
    container.innerHTML = "";
    if (!csvString) return;

    csvString.split(",").map(s => s.trim()).filter(Boolean).forEach(amount => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "gc-preset-btn";
      btn.dataset.amount = amount;
      btn.textContent = `${amount} ${currency_symbol}`;
      btn.addEventListener("click", () => {
        const priceInput = root.querySelector("#gcCustomPrice");
        if (priceInput) {
          priceInput.value = amount;
          priceInput.dispatchEvent(new Event("input"));
        }
        container.querySelectorAll(".gc-preset-btn").forEach(b => b.classList.remove("active"));
        btn.classList.add("active");
      });
      container.appendChild(btn);
    });

    // ── Botón "Otro" ──────────────────────────────────────────────────────
    const otroBtn = document.createElement("button");
    otroBtn.type = "button";
    otroBtn.className = "gc-preset-btn gc-preset-btn--otro";
    otroBtn.textContent = "Otro";
    otroBtn.addEventListener("click", () => {
      const priceInput = root.querySelector("#gcCustomPrice");
      if (priceInput) {
        priceInput.value = "";
        priceInput.focus();
      }
      container.querySelectorAll(".gc-preset-btn").forEach(b => b.classList.remove("active"));
      otroBtn.classList.add("active");
      if (previewAmount) previewAmount.textContent = "—";
    });
    container.appendChild(otroBtn);
  }

  const MIN_CUSTOM_AMOUNT = 140;
  root.querySelector("#gcCustomPrice")?.addEventListener("input", function () {
    const val = this.value;
    const num = parseFloat(val);

    // Feedback visual de error en el input
    this.classList.toggle("input--error", val !== "" && num < MIN_CUSTOM_AMOUNT);

    root.querySelectorAll(".gc-preset-btn").forEach(b => {
      b.classList.toggle("active", b.dataset.amount === val);
    });
    if (previewAmount) {
      if (val && num >= MIN_CUSTOM_AMOUNT) {
        const formatted = new Intl.NumberFormat(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(num);
        previewAmount.textContent = `${formatted} ${currency_symbol}`;
      } else {
        previewAmount.textContent = "—";
      }
    }
  });

  // ─── BIND: BOTONES DE IMPORTE ─────────────────────────────────────────────────

  function bindAmountButtons(buttons) {
    buttons.forEach(btn => {
      btn.addEventListener("click", () => {
        const variants = parseVariants(btn);
        const variant  = pickVariant(variants);

        updateVariantInput(variant);
        updatePreview({
          title:        btn.dataset.title || "",
          image:        btn.dataset.image || "",
          priceDisplay: variant ? formatPriceFromDecimal(variant.price) : "—",
        });
        setActiveEl(btn, ".giftcard-option");
        applyCardTemplate(btn.dataset.handle || "");
        updateSelectedInfo(btn.dataset.title || "", btn.dataset.description || "");

        currentAllowCustom = btn.dataset.allowCustom === "true";
        showCustomPriceField(currentAllowCustom);

        if (currentAllowCustom) {
          renderPresetAmounts(btn.dataset.presetAmounts || "");
        }

        const gcGrid = document.querySelector(".giftcards-header");
        if (gcGrid) gcGrid.scrollIntoView({ behavior: "smooth", block: "start" });

        if (addBtn) addBtn.disabled = false;
      });
    });
  }

  // ─── BIND: TARJETAS DE SERVICIO ───────────────────────────────────────────────

  function bindServiceCards(cards) {
    cards.forEach(card => {
      const selectBtn = card.querySelector(".gc-service-select");

      function onServiceSelect(e) {
        e?.stopPropagation();
        const variants = parseVariants(card);
        const variant  = pickVariant(variants);

        updateVariantInput(variant);
        updatePreview({
          title:        card.dataset.title || "",
          image:        card.dataset.image || "",
          priceDisplay: variant ? formatPriceFromDecimal(variant.price) : (card.dataset.priceDisplay || "—"),
        });
        setActiveEl(card, ".gc-service-card");
        applyCardTemplate(card.dataset.handle || "");
        updateSelectedInfo(card.dataset.title || "", card.dataset.description || "");

        currentAllowCustom = false;
        showCustomPriceField(false);

        const gcGrid = document.querySelector(".giftcards-header");
        if (gcGrid) gcGrid.scrollIntoView({ behavior: "smooth", block: "start" });

        if (addBtn) addBtn.disabled = false;
      }

      card.addEventListener("click", onServiceSelect);
      selectBtn?.addEventListener("click", onServiceSelect);
    });
  }

  // ─── CATEGORY FILTER ──────────────────────────────────────────────────────────

  function filterByCategory(cat) {
    const allCards = root.querySelectorAll(".gc-service-card");
    allCards.forEach(card => {
      card.style.display = card.dataset.category === cat ? "" : "none";
    });
    allCards.forEach(x => x.classList.remove("is-hidden", "active"));
    document.getElementById("gcFormWrap").classList.add("is-hidden");
    document.querySelectorAll(".gc-col--panel").forEach(p => p.classList.remove("active"));
  }

  catButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      catButtons.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");
      filterByCategory(btn.dataset.cat);
    });
  });

  // ─── ACCORDIONS ───────────────────────────────────────────────────────────────

  root.querySelectorAll(".gc-col-title-acordion").forEach(title => {
    title.addEventListener("click", () => {
      const currentCol = title.closest(".gc-col-acordion");

      document.querySelectorAll(".gc-col-acordion").forEach(el => {
        if (el !== currentCol && !el.classList.contains("is-hidden")) {
          el.classList.add("is-hidden");
        } else {
          el.classList.remove("is-hidden");
          document.querySelectorAll(".gc-col--panel").forEach(p => p.classList.remove("active"));
          document.querySelectorAll(".gc-service-card, .gc-item--amount").forEach(x => x.classList.remove("active"));
          document.getElementById("gcFormWrap").classList.add("is-hidden");
        }
      });

      title.classList.toggle("active");
      currentCol.classList.remove("is-hidden");
      currentCol.classList.toggle("collapsed");
    });
  });

  // ─── TIPO DE ENTREGA: mostrar/ocultar addons físicos ─────────────────────────

  const deliveryRadios  = document.querySelectorAll(".gc-delivery-radio");
  const physicalAddons  = document.getElementById("gcPhysicalAddons");

  function onDeliveryChange() {
    const isPhysical = document.querySelector('.gc-delivery-radio:checked')?.value === "Física";

    if (physicalAddons) {
      physicalAddons.style.display = isPhysical ? "block" : "none";
    }

    // Auto-marcar y bloquear la caja regalo al elegir Física
    const giftBoxCheckbox = physicalAddons?.querySelector(".gc-addon-checkbox");
    if (giftBoxCheckbox) {
      giftBoxCheckbox.checked  = isPhysical;
      giftBoxCheckbox.disabled = isPhysical;
    }

    if (!isPhysical) {
      physicalAddons?.querySelectorAll(".gc-addon-checkbox:checked").forEach(cb => {
        cb.checked  = false;
        cb.disabled = false;
      });
    }

    updateAddonsSummary();
  }
  deliveryRadios.forEach(radio => {
    radio.addEventListener("change", onDeliveryChange);
  });

  // Estado inicial (Digital por defecto = addons ocultos)
  onDeliveryChange();

  // ─── ADDONS: RESUMEN LATERAL ──────────────────────────────────────────────────

  function updateAddonsSummary() {
    const checked = document.querySelectorAll(".gc-addon-checkbox:checked");
    const summary  = document.getElementById("gcAddonsSummary");
    const list     = document.getElementById("gcAddonsList");
    if (!summary || !list) return;

    list.innerHTML = "";
    checked.forEach(cb => {
      const li = document.createElement("li");
      li.textContent = cb.dataset.addonTitle + " — " + cb.dataset.addonPrice;
      list.appendChild(li);
    });

    summary.style.display = checked.length ? "block" : "none";
  }

  // Bind de los checkboxes de addons (están en el DOM desde el liquid, no se cargan por AJAX)
  document.querySelectorAll(".gc-addon-checkbox").forEach(cb => {
    cb.addEventListener("change", updateAddonsSummary);
  });

  // ─── ADDONS: AGREGAR AL CARRITO ───────────────────────────────────────────────

  function getSelectedAddonVariantIds() {
    return Array.from(document.querySelectorAll(".gc-addon-checkbox:checked"))
      .map(cb => parseInt(cb.value, 10))
      .filter(Boolean);
  }

  async function addAddonsToCart() {
    const ids = getSelectedAddonVariantIds();
    if (!ids.length) return;

    const items = ids.map(id => ({ id, quantity: 1 }));

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) throw new Error(`Cart add failed: ${res.status}`);
    } catch (err) {
      console.error("Error agregando addons al carrito:", err);
    }
  }

  // ─── FORM SUBMIT ──────────────────────────────────────────────────────────────

  form?.addEventListener("submit", async (e) => {
    e.preventDefault(); // ← siempre preventDefault, ambos flujos van por Gadget

    const variantId = variantInput?.value;
    if (!variantId) {
      showToast("No hay un producto seleccionado.", "error");
      return;
    }

    let price;

    if (currentAllowCustom) {
      // Precio ingresado manualmente
      const priceInput = root.querySelector("#gcCustomPrice");
      const MIN_CUSTOM_AMOUNT = 140;
      price = parseFloat(priceInput?.value);
      if (!price || price < MIN_CUSTOM_AMOUNT) {
        showToast(`El monto mínimo es ${MIN_CUSTOM_AMOUNT} ${currency_symbol}.`, "error");
        return;
      }
    } else {
      // Precio fijo: leerlo desde el input hidden del variant
      const rawPrice = variantInput?.dataset.price;       // viene en centavos desde Liquid
      price = rawPrice ? Number(rawPrice) / 100 : null;

      if (!price || price <= 0) {
        showToast("No se pudo obtener el precio del producto.", "error");
        return;
      }
    }

    if (addBtn) {
      addBtn.disabled = true;
      addBtn.textContent = "Procesando...";
    }

    try {
      const res = await fetch(GADGET_ROUTE_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          variantId,
          quantity: 1,
          price,
          properties: getFormProperties(),
          addonVariantIds: getSelectedAddonVariantIds(),
        }),
      });

      const data = await res.json();

      if (data.checkoutUrl) {
        window.location.href = data.checkoutUrl;
      } else {
        showToast("Hubo un error al procesar. Intentá de nuevo.", "error");
      }
    } catch (err) {
      console.error("Draft order error:", err);
      showToast("Error de conexión. Intentá de nuevo.", "error");
    } finally {
      if (addBtn) {
        addBtn.disabled = false;
        addBtn.textContent = "Agregar al carrito";
      }
    }
  });

  // ─── PREVIEW MODAL ────────────────────────────────────────────────────────────

  const previewBtn   = root.querySelector("#gcPreviewButton");
  const modal        = document.getElementById("gcPreviewModal");
  const modalOverlay = modal?.querySelector(".gc-modal-overlay");
  const modalClose   = modal?.querySelector(".gc-modal-close");

  function formatDateDisplay(isoDate) {
    if (!isoDate) return null;
    const [y, m, d] = isoDate.split("-");
    return `${d}/${m}/${y}`;
  }

  function openPreviewModal() {
    const cardEl    = root.querySelector(".gc-item--amount.active .gc-item-title")
                   || root.querySelector(".gc-service-card.active .gc-service-name");
    const fromEl    = form.querySelector('[name="properties[Sender Name]"]');
    const toEl      = form.querySelector('[name="properties[Recipient Name]"]');
    const msgEl     = form.querySelector('[name="properties[Message]"]');
    const amountEl  = root.querySelector("#gcPreviewAmount");
    const productEl = root.querySelector("#gcPreviewProduct");
    const dateInput = form.querySelector("#gcSendDate");

    modal.querySelector("#gcModalSubtitle").textContent  = cardEl?.textContent || "—";
    modal.querySelector("#gcModalFrom").textContent      = fromEl?.value || "—";
    modal.querySelector("#gcModalTo").textContent        = toEl?.value   || "—";
    modal.querySelector("#gcModalMessage").textContent   = msgEl?.value  || "";
    modal.querySelector("#gcModalAmount").textContent    = amountEl?.textContent || "—";

    const subtitle = modal.querySelector("#gcModalSubtitle");
    if (subtitle) subtitle.textContent = productEl?.textContent || "Regalo elige el importe";

    // ── Fecha de envío en el modal ──
    const sendDateRow  = modal.querySelector("#gcModalSendDateRow");
    const sendDateSpan = modal.querySelector("#gcModalSendDate");
    if (sendDateRow && sendDateSpan) {
      const formatted = formatDateDisplay(dateInput?.value);
      if (formatted) {
        sendDateSpan.textContent = formatted;
        sendDateRow.style.display = "block";
      } else {
        sendDateSpan.textContent = "";
        sendDateRow.style.display = "none";
      }
    }

    modal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }

  function closePreviewModal() {
    modal?.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  previewBtn?.addEventListener("click", (e) => { e.preventDefault(); openPreviewModal(); });
  modalOverlay?.addEventListener("click", closePreviewModal);
  modalClose?.addEventListener("click", closePreviewModal);
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") closePreviewModal(); });

  // ─── FECHA MÍNIMA = HOY ───────────────────────────────────────────────────────

  const dateInput = document.getElementById("gcSendDate");
  if (dateInput) {
    const today = new Date();
    const yyyy  = today.getFullYear();
    const mm    = String(today.getMonth() + 1).padStart(2, "0");
    const dd    = String(today.getDate()).padStart(2, "0");
    const todayStr  = `${yyyy}-${mm}-${dd}`;
    dateInput.min   = todayStr;
    dateInput.value = todayStr;
  }

  // ─── AUTO-SELECCIÓN DESDE URL (?gc=handle) ────────────────────────────────────
  function autoSelectFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const handle = params.get("gc");
    if (!handle) return;

    // 1. Buscar en botones de importe
    const amountBtn = root.querySelector(`.gc-item--amount[data-handle="${handle}"]`);
    if (amountBtn) {
      // Abrir el acordeón de importes si está colapsado
      const amountCol = root.querySelector(".gc-col--amounts");
      if (amountCol?.classList.contains("collapsed")) {
        amountCol.querySelector(".gc-col-title-acordion")?.click();
      }
      amountBtn.click();
      amountBtn.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    // 2. Buscar en tarjetas de servicio
    const serviceCard = root.querySelector(`.gc-service-card[data-handle="${handle}"]`);
    if (serviceCard) {
      const category = serviceCard.dataset.category;

      // Abrir el acordeón de servicios si está colapsado
      const servicesCol = root.querySelector(".gc-col--services");
      if (servicesCol?.classList.contains("collapsed")) {
        servicesCol.querySelector(".gc-col-title-acordion")?.click();
      }

      // Activar la categoría correcta
      const catBtn = root.querySelector(`.gc-cat-btn[data-cat="${category}"]`);
      if (catBtn) {
        catBtn.click(); // esto llama a filterByCategory y activa el botón
      }

      // Seleccionar la tarjeta
      serviceCard.click();
      serviceCard.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  // ─── KICK OFF ─────────────────────────────────────────────────────────────────
  loadAllCollections();

});
